import React from "react";
import { connect } from "react-redux";
import validator from "validator";
import { ChangePasswordService } from "../../services/common/action";

 class ChangePassword extends React.Component {
  constructor(props) {

    super(props)
    this.state = {
      userType :"",
      access_token: "",
      username: "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      errors: {
        username: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      usernameValid: false,
      oldPasswordValid: false,
      newPasswordValid: false,
      confirmPasswordValid: false,
      formValid: false,
    };
  }
 



  componentDidMount() {
    if (this.props.profileDetails) {
      let username = this.props.profileDetails.commonUser.email;
      let access_token = this.props.loginDetails;
      let userType = this.props.profileDetails.commonUser.userType

      this.setState({
        access_token,
        username,
        userType
      })
    }
  }


  handleChange = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };

  validateField(fieldName, value) {
    const {
      errors,
      newPassword,
      confirmPassword,
      oldPasswordValid,
      newPasswordValid,
      confirmPasswordValid,
    } = this.state;

    let fieldValidationErrors = errors;
    let newPasswordvalid = newPasswordValid;
    let confirmPasswordvalid = confirmPasswordValid;

    switch (fieldName) {
    
      case "newPassword":
        newPasswordvalid =
          value.length >= 8 &&
          value.match(
            /(?=.*[_!@#$%^&*-])(?=.*\d)(?!.*[.\n])(?=.*[a-z])(?=.*[A-Z])^.{8,}$/
          );
        fieldValidationErrors.newPassword = newPasswordvalid
          ? ""
          : "Must contain at least one uppercase letter, one lowercase letter, one number, one special character and a minimum of 8 characters";
        break;
      case "confirmPassword":
        confirmPasswordvalid = validator.equals(value, newPassword);
        fieldValidationErrors.confirmPassword = confirmPasswordvalid
          ? ""
          : "Password does not match";
        break;

      default:
        break;
    }
    if (fieldName === "newPassword") {
      if (confirmPassword !== "") {
        if (value !== confirmPassword) {
          fieldValidationErrors.confirmPassword = "Password does not match.";
        } else {
          fieldValidationErrors.confirmPassword = "";
        }
      }
    } else if (fieldName === "confirmPassword") {
      if (value !== newPassword) {
        fieldValidationErrors.confirmPassword = "Password does not match.";
      } else {
        fieldValidationErrors.confirmPassword = "";
      }
    }


    this.setState({ 
      errors: fieldValidationErrors ,
      newPasswordValid: newPasswordvalid,
      confirmPasswordValid:confirmPasswordvalid
    }, 
    this.validateForm);
  }

  validateForm() {
    const {  newPasswordValid, confirmPasswordValid } = this.state;
    this.setState({ formValid: newPasswordValid && confirmPasswordValid });
  }

  changePassword = (e) => {
    e.preventDefault();
    const { access_token, username, oldPassword, newPassword, confirmPassword, } = this.state;

    var payLoad = {
      username, oldPassword, newPassword, confirmPassword
    };
     


    this.props.ChangePasswordService(access_token, payLoad, );
  }


  componentWillReceiveProps = nextProps => {
     
  };
  render() {
    const {  oldPassword, newPassword, confirmPassword, errors, formValid, } = this.state;

    return (
      <React.Fragment>
 
                      {/* Tab For Change Password */}
                      <div className="row tab-pane"    id="chang-pas">
                        <form onSubmit={this.changePassword} >
                          <div className="col-lg-12 col-md-12 col-sm-12 co-xs-12">

                            <h4>
                              Change Password
                                                    </h4>
                            <hr />

                          </div>

                          <div className="col-md-6">

                            <div className="form-group">
                              <label>Current Password</label>
                              <input type="password" onChange={this.handleChange}
                                name="oldPassword" value={oldPassword} placeholder="Current Password" className="form-control" />
                                 <div style={{ color: "red" }}>{errors.oldPassword}</div> 

                            </div>
                            <div className="form-group">
                              <label>New Password</label>
                              <input type="password" onChange={this.handleChange}
                                name="newPassword" value={newPassword} placeholder="New Password" className="form-control" />
                            <div style={{ color: "red" }}>{errors.newPassword}</div>
                            </div>
                            <div className="form-group">
                              <label>Confirm Password</label>
                              <input type="password" onChange={this.handleChange}
                                name="confirmPassword" value={confirmPassword} placeholder="Confirm Password" className="form-control" />
                            <div style={{ color: "red" }}>{errors.confirmPassword}</div>
                            </div>
                            <div className="text-right">
                            <button type="submit" disabled={!formValid} className="btnDefault">Submit 
                            </button>
                          </div>
                          </div>

                         
                        </form >
                      </div>

                    


      </React.Fragment>
    )
  }
}
const mapStateToProps = state => ({
  loginDetails: state.commonReducer.loginDetails,
  profileDetails: state.commonReducer.profileDetails,
  changePasswordStatus: state.commonReducer.changePasswordStatus,
  message: state.commonReducer.message,

});

const mapDispatchToProps = dispatch => ({
  ChangePasswordService: (token, payLoad) => dispatch(ChangePasswordService(token, payLoad))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);




 